// Quem pode MEXER numa assinatura — FONTE ÚNICA.
//
// Esta lista é consultada por dois lados que precisam concordar, e que até
// 2026-08-19 não concordavam:
//  1. back  → `upgrade/downgrade/transfer/discount.service` decidem 409
//  2. front → `subscriptions/[id].tsx` decide se o BOTÃO aparece
//
// O back mantinha uma lista NEGATIVA ("estes não podem") e o front uma lista
// POSITIVA ("estes podem"), escritas em épocas diferentes. Elas divergiam em
// `pending_provisioning`: o back aceitava, o front não oferecia o botão. Hoje
// isso só esconde uma operação válida; no sentido contrário, seria um botão que
// o usuário clica e leva 409 na cara.
//
// Lista NEGATIVA porque é assim que o back já pensava, e porque o default certo
// pra um status NOVO é "pode" — quem cria um status decide se ele bloqueia.

/**
 * Status que NÃO permitem mudar plano, dono ou preço da assinatura.
 *
 * O que todos têm em comum: ou a assinatura está morta, ou o cliente está sem
 * acesso e a operação não devolveria o acesso — ela só trocaria plano/dono/preço
 * e cobraria por isso.
 *
 * - `cancelada` / `encerrada`: acabou. Mexer é sempre erro de operação.
 * - `pending_cancellation`: ele já pediu pra sair.
 * - `suspensa`: cortado por falta de pagamento. Trocar de plano pela mão do
 *   admin entregaria plano novo sem receber o antigo. (O cliente PODE trocar
 *   pelo portal, porque lá trocar = substituir a fatura em aberto e pagá-la —
 *   ver `plan-change.service.ts`.)
 * - `trial_expired`: no grace de 7d, sem acesso. Como o registro conserva
 *   `nextBillingDate`, sem esta entrada o upgrade passava por todos os guards e
 *   cobrava pro-rata de quem continuava de fora — numa assinatura que o grace
 *   cancela em D+7.
 */
export const SUBSCRIPTION_LOCKED_FOR_CHANGES = [
  'cancelada',
  'suspensa',
  'trial_expired',
  'pending_cancellation',
  'encerrada',
] as const;

/** True se a assinatura aceita mudança de plano, dono ou preço. */
export function allowsSubscriptionChange(status: string): boolean {
  return !(SUBSCRIPTION_LOCKED_FOR_CHANGES as readonly string[]).includes(status);
}
